import React, { useContext, useState } from 'react';
import BookerContext from '../../context/bookerContext';
import BookerShortContext from '../../context/bookerShortContext';
import authService from '../../services/authService';
import { ReactComponent as MenuIcon } from '../../assets/img/menu-icon.svg';
import { ReactComponent as Profile } from '../../assets/img/user-regular-icon.svg';
import { ReactComponent as Wallet } from '../../assets/img/wallet-icon.svg';
import { ReactComponent as History } from '../../assets/img/history-icon.svg';
import { ReactComponent as Gift } from '../../assets/img/gift-icon.svg';
import { ReactComponent as Support } from '../../assets/img/support-icon.svg';
import { ReactComponent as Legal } from '../../assets/img/legal-icon.svg';
import { ReactComponent as SignOut } from '../../assets/img/sign-out-icon.svg';
import { ReactComponent as CloseIcon } from '../../assets/img/close-white-icon.svg';
import ProfileMenu from '../Menu/ProfileMenu';
import PaymentsMenu from '../Menu/PaymentsMenu';
import '../../assets/styles/menu.sass';

const Menu = ({ isProcessing }) => {
  const context = useContext(BookerContext);
  const { togglePopup } = useContext(BookerShortContext);
  const {
    state: { step, userProfile },
    updateStep,
    updateEditor,
    updatePreviousStep,
  } = context;

  const [isOpen, setIsOpen] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [openPayments, setOpenPayments] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    setOpenProfile(false);
    setOpenPayments(false);
  };

  const getUserInitials = () => {
    if (!userProfile) return;

    const { first_name, last_name } = userProfile;
    const f = first_name.slice(0, 1);
    const l = last_name.slice(0, 1);

    return f + l;
  };

  const profileClickHandler = () => {
    setOpenProfile(true);
  };

  const paymentsClickHandler = () => {
    if (isProcessing) return;
    setOpenPayments(true);
  };

  const rideHistoryClickHandler = () => {
    if (isProcessing) return;
    if (step !== 14) updatePreviousStep(step);
    updateEditor('');
    updateStep(14);
    toggleMenu();
  };

  const referEarnClickHandler = () => {
    return false;
  };

  const supportClickHandler = () => {
    window.open('https://gocurb.force.com/s/', '_blank');
  };

  const legalClickHandler = () => {
    window.open('https://gocurb.com/terms/', '_blank');
  };

  const logOutAndReload = () => {
    authService.logOut();
    window.location.reload();
  };

  const logoutClickHandler = () => {
    if (isProcessing) return;
    const logOutBtn = [
      {
        isSecondary: true,
        textBtn: 'Cancel',
      },
      {
        clickHandler: logOutAndReload,
        textBtn: 'OK',
      },
    ];
    togglePopup(true, 'logOut', logOutBtn);
  };

  return (
    <div className="menu-container">
      <div id="menu-icon" className="animated fadeIn" onClick={toggleMenu}>
        <MenuIcon className="menu-icon" />
        <div className="user-name">{getUserInitials()}</div>
      </div>

      {isOpen && (
        <div className="animated fadeIn clearfix" id="menu-info-dropdown">
          <CloseIcon onClick={toggleMenu} className="close-icon" />
          {openProfile && <ProfileMenu setOpenProfile={setOpenProfile} />}
          {openPayments && (
            <PaymentsMenu toggleMenu={toggleMenu} setOpenPayments={setOpenPayments} isProcessing={isProcessing} />
          )}
          {!openProfile && !openPayments && (
            <ul className="dropdown-list clearfix">
              <li className="dropdown-item" onClick={profileClickHandler}>
                <Profile />
                Profile
              </li>
              <li className={`dropdown-item${isProcessing ? ' disabled' : ''}`} onClick={paymentsClickHandler}>
                <Wallet />
                Payments
              </li>
              <li className={`dropdown-item${isProcessing ? ' disabled' : ''}`} onClick={rideHistoryClickHandler}>
                <History />
                Ride History
              </li>
              <li className="dropdown-item disabled" onClick={referEarnClickHandler}>
                <Gift />
                Refer & Earn
              </li>
              <li className="dropdown-item" onClick={supportClickHandler}>
                <Support />
                Support
              </li>
              <li className="dropdown-item" onClick={legalClickHandler}>
                <Legal />
                Legal
              </li>
              <li className={`dropdown-item${isProcessing ? ' disabled' : ''}`} onClick={logoutClickHandler}>
                <SignOut />
                Logout
              </li>
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default Menu;
